import request from '@/api/request'

export default {
  async addAccount (code) {
    return (await request.get(`module/action/marketplace/mercadoLivre/account/add/${code}`)).data
  },
  async getAccounts (options) {
    return (await request.get(`module/action/marketplace/mercadoLivre/account/index`, {
      params: options
    })).data
  },
  async getSizeGrids (data) {
    return (await request.get(`module/action/marketplace/mercadoLivre/size_grid/index`, {
      params: data
    })).data
  },
  async getSizeGrid (identifier) {
    return (await request.get(`module/action/marketplace/mercadoLivre/size_grid/retrieve/${identifier}`)).data
  },
  async deleteSizeGrid (identifier) {
    return (await request.get(`module/action/marketplace/mercadoLivre/size_grid/delete/${identifier}`)).data
  },
  /**
   * Salva produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async saveProduct (product) {
    return (await request.post(`module/action/marketplace/mercadoLivre/product/save`, product)).data
  },
  /**
   * Atualiza o produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async updateProduct (product) {
    return (await request.post(`module/action/marketplace/mercadoLivre/product/edit`, product)).data
  },
  /**
   * Atualiza o preço do produto no módulo.
   *
   * @param {Object} product
   * @returns {Promise.<Object>}
   */
  async updateProductPrice (product) {
    return (await request.post(`module/action/marketplace/mercadoLivre/product/edit_price`, product)).data
  },
  /**
   * Sincroniza pedido por tipo e identificador do módulo e conta do ML.
   *
   * @param {String} type
   * @param {String} identifier
   * @param {String} code
   * @param {String} account
   * @returns {Object} Pedido sincronizado
   */
  async syncOrder (type, identifier, code, account) {
    return (await request.get(`module/action/${type}/${identifier}/order/sync/${code}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Busca um produto pelo código do ML.
   *
   * @param {String} code
   * @param {String} account
   * @returns {Object} anúncio
   */
  async retrieveByCode (code, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/retrieve_by_code/${code}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Atualiza informações pendentes do pedido da modalidade entrega a combinar.
   *
   * @param {Object} order
   * @returns {Object} Pedido atualizado
   */
  async updateOrderPendingInformations (order) {
    return (await request.post(`module/action/marketplace/mercadoLivre/order/update_informations`, order)).data
  },
  /**
   * Retorna as categorias do ML.
   *
   * @param {String} account
   * @param {String} categoryId
   * @returns {Object}
   */
  async getCategories (account, categoryId) {
    if (!account) {
      account = await this.getActiveAccountId()
    }

    if (categoryId !== undefined) {
      return (await request.get(`module/action/marketplace/mercadoLivre/category/retrieve/${categoryId}`, {
        headers: {
          'MercadoLivre-Account': account
        }
      })).data
    }

    return (await request.get(`module/action/marketplace/mercadoLivre/category/retrieve`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna as informações da categoria do ML.
   *
   * @param {String} account
   * @param {String} categoryId
   * @param {String} variationCombination
   * @returns {Object}
   */
  async getCategoryInfo (account, categoryId, variationCombination) {
    if (!account) {
      account = await this.getActiveAccountId()
    }

    if (variationCombination !== undefined) {
      return (await request.get(`module/action/marketplace/mercadoLivre/category/info/${categoryId}/${variationCombination.replace(/\+/g, '_-_')}`, {
        headers: {
          'MercadoLivre-Account': account
        }
      })).data
    }

    return (await request.get(`module/action/marketplace/mercadoLivre/category/info/${categoryId}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna url de etiqueta de envio do pedido.
   *
   * @param shipmentIds
   * @param account
   * @returns {Promise<void>}
   */
  async getShipmentLabelUrl (shipmentIds, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/order/shipmentLabelUrl`, shipmentIds, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna as regras de frete grátis do ML.
   *
   * @param {String} categoryId
   * @param account
   * @param {String} dimensions
   * @returns {Object}
   */
  async getShippingRules (categoryId, account, dimensions) {
    return (await request.get(`module/action/marketplace/mercadoLivre/shipping/retrieve/${categoryId}/${dimensions}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Atualiza o status da conta do ML.
   *
   * @param {String} identifier
   * @param {Boolean} status
   * @returns {Object}
   */
  async updateAccountStatus (identifier, status) {
    if (status) {
      return (await request.get(`module/action/marketplace/mercadoLivre/account/active/${identifier}`)).data
    }
    return (await request.get(`module/action/marketplace/mercadoLivre/account/inactive/${identifier}`)).data
  },
  /**
   * Renova o token de uma conta.
   *
   * @param {String} identifier
   * @returns {Object}
   */
  async refreshToken (identifier) {
    return (await request.get(`module/action/marketplace/mercadoLivre/account/refresh_token/${identifier}`)).data
  },
  /**
   * Retorna os anúncios para migração.
   *
   * @param options
   * @param account
   * @returns {Promise<void>}
   */
  async getAnnouncementsMigration (options, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product_migration`, {
      params: options,
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna os detalhes de um anúncio de migração.
   *
   * @param options
   * @param account
   * @returns {Promise<void>}
   */
  async getAnnouncementMigrationDetails (code, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product_migration/retrieve/${code}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna os statuses dos anúncios de migração.
   *
   * @param account
   * @returns {Promise<void>}
   */
  async getAnnouncementMigrationStatuses (account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product_migration/retrieve_announcement_statuses`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Salva um anúncio migrado.
   *
   * @param announcement
   * @param account
   * @returns {Promise<void>}
   */
  async saveAnnouncementMigration (announcement, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/product_migration/save`, announcement, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna os anúncios disponíveis para catálogo.
   *
   * @param options
   * @param account
   * @returns {Promise<void>}
   */
  async getAnnouncementCatalog (options, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/catalog/retrieve_all_elegible`, {
      params: options,
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Retorna os dados da conta, buscando pelo código de autorização.
   *
   * @param code
   * @returns {Promise<*>}
   */
  async getAccount (code) {
    return (await request.get(`module/action/marketplace/mercadoLivre/account/retrieve/${code}`)).data
  },
  /**
   * Retorna id de conta ativa.
   *
   * @returns string
   */
  async getActiveAccountId () {
    const accounts = (await this.getAccounts({})).items.sort((a, b) => b.active - a.active)
    return accounts.length && accounts[0].active ? accounts[0].identifier : null
  },
  /**
   * Deleta uma conta de acordo com o identifier.
   *
   * @param identifier
   * @returns {Promise<*>}
   */
  async deleteAccountByIdentifier (identifier) {
    return (await request.get(`module/action/marketplace/mercadoLivre/account/deleteAccountByIdentifier/${identifier}`)).data
  },
  /**
   * Retorna as lojas oficiais do ML.
   *
   * @param account
   * @returns {Promise<*>}
   */
  async getOfficialStores (account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/official_store`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Remove o vínculo do anúncio com o hub.
   *
   * @param String id
   * @returns {Promise<*>}
   */
  async deleteProduct (id, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/delete/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  async deleteAnnouncement (id, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/delete_announcement/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Ativa um anúncio.
   *
   * @param id
   * @param account
   * @return {Promise<*>}
   */
  async activateAnnouncement (id, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/activate/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Pausa um anúncio.
   *
   * @param id
   * @param account
   * @return {Promise<*>}
   */
  async pauseAnnouncement (id, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/product/pause/${id}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Busca produto do catálogo.
   *
   * @param ean
   * @return {Promise<*>}
   */
  async getProductCatalog (ean) {
    return (await request.get(`module/action/marketplace/mercadoLivre/catalog/retrieve/${ean}`)).data
  },
  /**
   * Busca de uma variação do produto esta disponível para o tipo catálogo.
   *
   * @param ean
   * @param account
   * @return {Promise<*>}
   */
  async retrieveVariationElegibleToCatalog (ean, account) {
    return (await request.get(`module/action/marketplace/mercadoLivre/catalog/retrieve_variation_elegible_to_catalog/${ean}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Realiza um match do produto para o tipo catálogo no mercado livre.
   *
   * @param data
   * @param account
   * @return {Promise<*>}
   */
  async matchCatalog (data, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/catalog/match_announcement_to_catalog`, data, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Busca as tabela de medidas personalizadas de acordo com a marca e gênero selecionadas
   *
   * @param data
   * @param account
   * @return {Promise<*>}
  */
  async getCustomSizeGridList (data, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/size_grid/get_custom_measurement_chart`, data, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  /**
   * Cria tabela de medidas no mercado livre
   *
   * @param data
   * @param account
   * @return {Promise<*>}
  */
  async createSizeGrid (sizeGrid, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/size_grid/create`, sizeGrid, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  async updateSizeGrid (sizeGrid) {
    return (await request.put(`module/action/marketplace/mercadoLivre/size_grid/update`, sizeGrid)).data
  },
  /**
   * Cancelar migração
   *
   * @param announcement
   * @param account
   * @returns {Promise<void>}
   */
  async deleteAnnouncementMigration (announcement, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/product_migration/delete/${announcement}/${account}`, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  async getDomainTechnicalSpecs (data, account) {
    return (await request.post(`module/action/marketplace/mercadoLivre/size_grid/getTechnicalSpecs`, data, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  },
  async getDomains () {
    return (await request.get(`module/action/marketplace/mercadoLivre/size_grid/getDomains`)).data
  },
  /**
   * Reprocessa preço ou estoque de produtos no Mercado Livre.
   *
   * @param {string} type
   * @param {string} identifier
   * @oaram {Object} options
   * @returns {Promise.<Object>}
   */
  async reprocess (type, identifier, options, account) {
    return (await request.post(`module/action/${type}/${identifier}/reprocess`, {
      params: options
    }, {
      headers: {
        'MercadoLivre-Account': account
      }
    })).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/mercadoLivre/index.js